import React from "react";
import "../styles/Loginform.css";
import LoginOtp from "./LoginOtp";
import LoginWithPass from "./LoginNormal";

class Loginform extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: props.redirect,
      loginType: "normal"
    };
  }
  loginUsingOtp = () => {
    this.setState({
      loginType: "otp"
    });
  };

  loginUsingPass = () => {
    this.setState({
      loginType: "normal"
    });
  };

  render() {
    const element =
      this.state.loginType === "normal" ? (
        <LoginWithPass
          redirect={this.props.redirect}
          loginUsingotps={this.loginUsingOtp}
        />
      ) : (
        <LoginOtp
          redirect={this.props.redirect}
          loginUsingPass={this.loginUsingPass}
        />
      );
    return <React.Fragment>{element}</React.Fragment>;
  }
}

export default Loginform;



// WEBPACK FOOTER //
// ./src/components/Loginform.js